import styled from "styled-components";
import BlurMap from "../../../assets/blur-map.jpg";

interface StylesheetProps {
  isMobile: boolean;
  isBlocked: boolean;
}

const className = "vehicle-travel-details__dialog";

export const ModalVehicleAndTravelDetailsStylesheet = styled.div.attrs(
  (props) => ({ ...props, className, id: className })
)<StylesheetProps>`
  display: flex;
  max-height: calc(100% - 64px);
  flex-direction: column;
  position: relative;
  overflow-y: auto;

  .vehicle-travel-details__header {
    display: flex;
    justify-content: space-between;
    ${(props) => (props.isMobile ? "flex-direction: column;" : "")}
    align-items: center;
    flex: 0 0 auto;
    margin: 0;
    padding: ${(props) => (props.isMobile ? "10px" : "16px 24px")};

    .vehicle-travel-details__title {
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      font-size: 1.25rem;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      font-weight: 500;
      line-height: 1.6;
      letter-spacing: 0.0075em;
      margin: 0;
      color: rgba(0, 0, 0, 0.87);

      .icon {
        padding: 10px;
        border-radius: 50%;
        width: ${(props) => (props.isMobile ? "35px" : "50px")};
        height: ${(props) => (props.isMobile ? "35px" : "50px")};

        ${(props) => (props.isMobile ? "display: flex;" : "")}
        ${(props) => (props.isMobile ? "justify-content: center;" : "")}
        .iconBT, .iconBM {
          svg {
            position: relative;
            ${(props) => (props.isMobile ? "bottom: 4px; width: 20px;" : "top: 3px; right: 2px;")}
          }
        }

        .iconPC {
          svg {
            position: relative;
            width: ${(props) => (props.isMobile ? "20px" : "35px")};
            right: ${(props) => (props.isMobile ? "1px" : "3px")};
            ${(props) => (props.isMobile ? "bottom: 6px;" : "top: 1px;")}
          }
        }

        .iconVA {
          svg {
            position: relative;
            width: ${(props) => (props.isMobile ? "20px" : "35px")};
            ${(props) => (props.isMobile ? "bottom: 2px;" : "top: 5px; right: 3px;")}
          }
        }

        .iconCA {
          svg {
            position: relative;
            ${(props) => (props.isMobile ? "bottom: 18px; width: 28px;" : "bottom: 11px; width: 36px; right: 2px;")}
          }
        }

        .iconBlocked {
          svg {
            position: relative;
            ${(props) => (props.isMobile ? "bottom: 11px; width: 25px;" : "bottom: 3px; right: 2px; width: 35px;")}
          }
        }
        .iconMaintenance {

          svg {
            position: relative;
            right: 2px;
            width: 35px;
            bottom: 5px;
          }
        }
      }

      .content {
        padding-left: 15px;

        ${(props) => (props.isMobile ? "" : "font-weight: 200;")}
        .content__title {
          font-size: ${(props) => (props.isMobile ? "1rem" : " 1.25rem")};
        }

        .content__subtitle {
          font-size: ${(props) => (props.isMobile ? "0.8rem" : "1rem")};
          color: #666666;
        }
      }
    }

    .actions {
      display: flex;
      gap: 2rem;
    }

    .block_button {
      color: white;
      background-color: ${(props) => (props.isBlocked ? "#00AD00" : "#F00")};
      border-radius: 8px;
      padding: ${(props) => (props.isMobile ? "0 8px 0 8px" : "")};
    }

    .maintenance_button {
      color: white;
      background-color: #666666;
      border-radius: 8px;
      padding: ${(props) => (props.isMobile ? "0 8px 0 8px" : "")};
    }
    .create_alert_button{
      color: white;
      height: ${(props) => (props.isMobile ? "35px" : "50px")};
      background-color: #00AD00;
      border-radius: 8px;
      padding: ${(props) => (props.isMobile ? "0 8px 0 8px" : "")};
    }
    .show_speed_alert_button{
      color: white;
      height: ${(props) => (props.isMobile ? "35px" : "50px")};
      border-radius: 8px;
      padding: ${(props) => (props.isMobile ? "0 8px 0 8px" : "")};
      width: ${(props) => (props.isMobile ? "" : "250px")};

      .MuiSvgIcon-root {
        width: 0.4em;
        height: 0.4em;
      }
    }
  }

  .vehicle-travel-details__content {
    display: flex;

    .vehicle-travel-details__status .content {
      display: flex;
      -webkit-box-align: center;
      align-items: center;
    }

    .vehicle-travel-details__map {
      margin-top: 10px;
      margin-bottom: 10px;

      .hidden {
        display: none !important;
      }

      .vehicle-travel-details__travel-map {
        display: grid;
        gap: 8px;

        .travel-map__main,
        .travel-map__side {
          display: grid;
          gap: 4px;
          min-width: 0;
          align-content: start;
        }

        /* Full screen: the map with its replay on the left, travel data, timeline and legend on the right */
        &.is-fullscreen {
          grid-template-columns: minmax(0, 1fr) 400px;
          gap: 16px;
          width: 100%;
          height: 100%;
          padding: 16px;
          box-sizing: border-box;
          background: #FFFFFF;
          overflow: hidden;

          /* Where the browser refuses full screen: the same layout over the whole window, above the dialog */
          &.is-window {
            position: fixed;
            inset: 0;
            z-index: 1400;
          }

          .travel-map__main {
            grid-template-rows: minmax(0, 1fr) auto;
            min-height: 0;
          }

          .vehicle-travel-details__map-area {
            height: 100%;
            min-height: 0;
          }

          .travel-map__side {
            gap: 12px;
            min-height: 0;
            padding-right: 4px;
            overflow-y: auto;
          }

          .travel-map__details {
            padding-bottom: 12px;
            border-bottom: 1px solid #EEEEEE;
          }

          /* Narrow screens (phone): map on top, then the replay bar, then travel data, timeline and legend,
             all in one scroll */
          @media (max-width: 900px) {
            /* Rows sized by their content (max-content): with a fixed height, auto rows would shrink and overlap */
            grid-template-columns: minmax(0, 1fr);
            grid-template-rows: max-content max-content;
            align-content: start;
            gap: 12px;
            padding: 8px;
            overflow-y: auto;

            .travel-map__main {
              grid-template-rows: 62vh max-content;
              min-height: auto;
            }

            .travel-map__side {
              min-height: auto;
              overflow: visible;
              padding-right: 0;
            }
          }
        }
      }

      .vehicle-travel-details__map-area {
        position: relative;

        .map-fullscreen {
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 1;
          display: grid;
          place-items: center;
          width: 40px;
          height: 40px;
          padding: 0;
          border: 0;
          border-radius: 2px;
          background: #FFFFFF;
          box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
          color: #666666;
          cursor: pointer;

          svg {
            font-size: 28px;
          }

          &:hover {
            color: #333333;
          }

          &:focus-visible {
            outline: 2px solid #1976D2;
            outline-offset: 2px;
          }

          /* Not used yet in this browser: a pulsing ring invites to open the full analysis view */
          &.is-new {
            color: #1976D2;

            &::after {
              content: "";
              position: absolute;
              inset: -4px;
              border: 2px solid #1976D2;
              border-radius: 6px;
              pointer-events: none;
              animation: travel-map-fullscreen-pulse 1.6s ease-out infinite;
            }
          }
        }

        /* "Play from here", at the end of a point's card */
        .replay-from {
          display: block;
          width: 100%;
          margin-top: 8px;
          padding: 5px 8px;
          border: 1px solid #C5CAE9;
          border-radius: 6px;
          background: #F5F7FF;
          color: #1A237E;
          font: inherit;
          font-size: 12px;
          font-weight: 500;
          text-align: center;
          cursor: pointer;

          &:hover {
            background: #E8EAF6;
          }

          &:focus-visible {
            outline: 2px solid #1976D2;
            outline-offset: 1px;
          }
        }
      }

      @keyframes travel-map-fullscreen-pulse {
        0% {
          opacity: 0.9;
          transform: scale(0.9);
        }

        100% {
          opacity: 0;
          transform: scale(1.35);
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .vehicle-travel-details__map-area .map-fullscreen.is-new::after {
          animation: none;
          opacity: 0.6;
        }
      }

      .vehicle-travel-details__route-menu {
        position: absolute;
        z-index: 2;
        display: grid;
        min-width: 210px;
        padding: 6px;
        border-radius: 8px;
        background: #FFFFFF;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
        font-family: "Roboto", "Helvetica", "Arial", sans-serif;
        font-size: 13px;

        .menu-title {
          padding: 4px 8px 6px;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          color: #757575;
        }

        button {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 6px 8px;
          border: 0;
          border-radius: 6px;
          background: none;
          color: #212121;
          font: inherit;
          text-align: left;
          cursor: pointer;

          svg {
            font-size: 18px;
            color: #424242;
          }

          &:hover,
          &:focus-visible {
            background: #F5F5F5;
            outline: none;
          }
        }
      }

      /* Replay HUD over the map: speedometer, time and state, trip from the plant to the obra */
      @media (max-width: 600px) {
        .vehicle-travel-details__map-area .travel-hud {
          left: 6px;
          right: 52px;
          bottom: 22px;
          gap: 6px;

          .hud-row {
            gap: 6px;
          }

          .hud-speed {
            width: 54px;
            height: 54px;
            border-width: 3px;

            .hud-speed__value {
              font-size: 18px;
            }

            .hud-speed__unit {
              font-size: 8px;
            }
          }

          .hud-card {
            padding: 6px 8px;
          }

          .hud-time {
            font-size: 15px;
          }

          .hud-elapsed {
            font-size: 11px;
          }

          .hud-state {
            font-size: 12px;
          }

          .hud-trip {
            grid-template-columns: 22px minmax(80px, 1fr) 22px;
            padding: 6px 8px 4px;
          }

          .hud-trip-label {
            font-size: 11px;
          }
        }

        .travel-map__main .vehicle-travel-details__replay {
          gap: 4px 8px;

          .replay-slider {
            flex-basis: 100%;
            order: 3;
          }
        }
      }

      .travel-hud {
        position: absolute;
        left: 12px;
        right: 64px;
        bottom: 26px;
        z-index: 1;
        display: grid;
        justify-items: start;
        gap: 8px;
        font-family: "Roboto", "Helvetica", "Arial", sans-serif;
        color: #212121;
        pointer-events: none;

        .hud-row {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .hud-speed {
          display: grid;
          align-content: center;
          justify-items: center;
          width: 70px;
          height: 70px;
          border: 4px solid #37474F;
          border-radius: 50%;
          background: #FFFFFF;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
          line-height: 1;

          .hud-speed__value {
            font-size: 24px;
            font-weight: 700;
            font-variant-numeric: tabular-nums;
          }

          .hud-speed__unit {
            margin-top: 3px;
            font-size: 9.5px;
            color: #616161;
            white-space: nowrap;
          }

          &.is-over {
            border-color: #B71C1C;
            background: #D32F2F;
            color: #FFFFFF;

            .hud-speed__unit {
              color: rgba(255, 255, 255, 0.9);
            }
          }
        }

        .hud-card {
          display: grid;
          gap: 4px;
          padding: 8px 12px;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.96);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        }

        .hud-time {
          font-size: 19px;
          font-weight: 600;
          line-height: 1.1;
          font-variant-numeric: tabular-nums;

          small {
            margin-left: 6px;
            font-size: 12px;
            font-weight: 400;
            color: #757575;
          }
        }

        .hud-elapsed {
          font-size: 12px;
          color: #616161;
          font-variant-numeric: tabular-nums;
        }

        .hud-state {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13.5px;
          font-weight: 500;
        }

        .hud-state-icon {
          display: grid;
          place-items: center;
          width: 30px;
          height: 30px;
          border: 2px solid transparent;
          border-radius: 50%;
          background: #FFFFFF;

          div, span {
            display: block;
            width: 24px;
            height: 24px;
          }

          svg {
            display: block;
            width: 24px;
            height: 24px;
          }
        }

        .hud-trip {
          display: grid;
          grid-template-columns: 28px minmax(140px, 1fr) 28px;
          align-items: center;
          gap: 4px 10px;
          width: min(440px, 100%);
          padding: 8px 12px 6px;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.96);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

          &.is-automatic {
            grid-template-columns: 30px auto;
            width: auto;
          }
        }

        .hud-trip-icon {
          display: block;
          width: 28px;
          height: 28px;

          div, span {
            display: block;
            width: 28px;
            height: 28px;
          }

          svg {
            display: block;
            width: 28px;
            height: 28px;
          }
        }

        .hud-track {
          position: relative;
          height: 30px;

          &::before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            top: 50%;
            height: 4px;
            margin-top: -2px;
            border-radius: 2px;
            background: repeating-linear-gradient(90deg, #BDBDBD 0 8px, transparent 8px 14px);
          }
        }

        .hud-track-done {
          position: absolute;
          top: 50%;
          height: 4px;
          margin-top: -2px;
          border-radius: 2px;
        }

        .hud-truck {
          position: absolute;
          top: 50%;
          width: 32px;
          height: 32px;
          transform: translate(-50%, -50%);
          transition: left 0.2s linear;

          div, span {
            display: block;
            width: 32px;
            height: 32px;
          }

          svg {
            display: block;
            width: 32px;
            height: 32px;
          }

          &.is-returning {
            transform: translate(-50%, -50%) scaleX(-1);
          }
        }

        .hud-trip-label {
          grid-column: 1 / -1;
          font-size: 12px;
          font-weight: 500;
          color: #424242;
          text-align: center;
        }

        .hud-auto-tag {
          display: inline-block;
          margin-left: 8px;
          padding: 1px 8px;
          border-radius: 999px;
          background: #ECEFF1;
          color: #455A64;
          font-size: 11px;
          font-weight: 500;
        }

        .is-automatic .hud-trip-label {
          grid-column: auto;
          text-align: left;
        }
      }

      .vehicle-travel-details__replay {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px 12px;
        padding: 0 4px;
        font-family: "Roboto", "Helvetica", "Arial", sans-serif;
        font-size: 12.5px;
        color: #424242;

        .replay-slider {
          flex: 1;
          min-width: 140px;
        }

        .replay-clock {
          min-width: 76px;
          color: #757575;
          font-variant-numeric: tabular-nums;
        }

        .replay-rates {
          display: inline-flex;
          border: 1px solid #E0E0E0;
          border-radius: 6px;
          overflow: hidden;

          button {
            padding: 3px 8px;
            border: 0;
            background: none;
            color: #616161;
            font: inherit;
            font-size: 12px;
            cursor: pointer;

            &.is-on {
              background: #424242;
              color: #FFFFFF;
            }

            &:focus-visible {
              outline: 2px solid #1976D2;
              outline-offset: -2px;
            }
          }
        }
      }

      .vehicle-travel-details__map-timeline {
        display: grid;
        gap: 6px;
        padding: 10px 4px 0;
        font-family: "Roboto", "Helvetica", "Arial", sans-serif;
        font-size: 12.5px;
        color: #424242;

        .timeline-toggle {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          justify-self: start;
          padding: 2px 6px 2px 0;
          border: 0;
          background: none;
          color: #757575;
          font: inherit;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          cursor: pointer;

          &:hover {
            color: #212121;
          }

          &:focus-visible {
            outline: 2px solid #1976D2;
            outline-offset: 2px;
          }

          .timeline-chevron {
            font-size: 18px;
            transform: rotate(-90deg);
            transition: transform 0.15s;

            &.is-open {
              transform: none;
            }
          }
        }

        ol {
          display: grid;
          gap: 2px;
          margin: 0;
          padding: 0;
          list-style: none;
        }

        li button {
          display: grid;
          grid-template-columns: 24px 82px minmax(0, 1fr) auto;
          gap: 8px;
          align-items: center;
          width: 100%;
          padding: 4px 6px;
          border: 0;
          border-radius: 6px;
          background: none;
          color: inherit;
          font: inherit;
          text-align: left;
          cursor: pointer;

          &:hover {
            background: #F5F5F5;
          }

          &:focus-visible {
            outline: 2px solid #1976D2;
            outline-offset: 1px;
          }
        }

        .badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          font-size: 11px;
          font-weight: 700;

          &.is-dot {
            width: 12px;
            height: 12px;
            margin-left: 5px;
            border: 2px solid #FFFFFF;
            box-shadow: 0 0 0 1px #BDBDBD;
          }
        }

        .when {
          color: #757575;
          font-variant-numeric: tabular-nums;
        }

        .justified-check {
          color: #2E7D32;
          font-size: 16px;
        }

        .what {
          min-width: 0;

          b {
            font-weight: 500;
          }

          .detail {
            margin-left: 6px;
            color: #757575;
          }
        }
      }

      .vehicle-travel-details__map-legend {
        display: grid;
        gap: 8px;
        padding: 10px 4px 0;
        font-family: "Roboto", "Helvetica", "Arial", sans-serif;
        font-size: 12.5px;
        color: #424242;

        .legend-row {
          display: grid;
          gap: 6px;
        }

        .legend-items {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 6px 12px;
        }

        .legend-label {
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          color: #757575;
        }

        .legend-toggle {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 3px 10px;
          border: 1px solid #E0E0E0;
          border-radius: 999px;
          background: #FFFFFF;
          color: #9E9E9E;
          font: inherit;
          cursor: pointer;

          &.is-on {
            border-color: #BDBDBD;
            color: #212121;
          }

          &:not(.is-on) .swatch {
            opacity: 0.35;
          }

          &:hover {
            background: #F5F5F5;
          }

          &:focus-visible {
            outline: 2px solid #1976D2;
            outline-offset: 2px;
          }
        }

        .legend-item {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          cursor: help;

          &:focus-visible {
            outline: 2px solid #1976D2;
            outline-offset: 2px;
          }

          .legend-help {
            font-size: 14px;
            color: #9E9E9E;
          }
        }

        .swatch-pair {
          display: inline-flex;
          gap: 2px;
        }

        .swatch {
          display: inline-block;
          flex: 0 0 auto;

          &.dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
          }

          &.line {
            width: 18px;
            height: 4px;
            border-radius: 2px;
          }
        }

        .area {
          display: inline-block;
          flex: 0 0 auto;
          width: 14px;
          height: 14px;
          border: 2px solid;
          border-radius: 50%;
        }

        .legend-hint {
          margin: 0;
          font-size: 12px;
          color: #757575;
        }
      }

      .vehicle-travel-details__map-info-content {
        min-width: 120px;

        .block {
          padding: 0 5px;
        }

        .first {
          text-align: center;
          margin-bottom: 15px;

          .icon {

            img {
              width: 20px;
            }
          }
        }

        .second {
          width: 100%;

          .content {
            display: flex;
            justify-content: space-between;

            .title {
              font-weight: 400;
            }

            .text {
              padding-left: 15px;
              text-align: right;
            }
          }
        }
      }
    }

    .vehicle-travel-details__map {

      .vehicle-travel-details__map--static {
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        height: 400px;
        -webkit-box-align: center;
        align-items: center;
        background-image: url(${BlurMap});
        background-repeat: no-repeat;
        background-size: cover;

        .vehicle-travel-details__map-icon {
          cursor: pointer;
          width: 40px;
          border-radius: 50%;
          font-weight: bold;
        }
      }
    }

  }

  .vehicle-travel-details__content--desktop {

    .vehicle-travel-details__list {

      .vehicle-travel-details__item-grid {
        height: 70vh;
        overflow-y: auto;
        overflow-x: hidden;

        .vehicle-travel-details__work-header {

          .box {
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: justify;
            justify-content: space-between;

            .title {
              color: black;
              font-weight: 300;
              font-size: 1.5rem;
            }

            .text {
              color: rgb(102, 102, 102);
            }
          }
        }

        .vehicle-travel-details__events {
          margin-bottom: 15px;

          .block {
            margin-bottom: 20px;
          }

          :last-child {
            margin-bottom: 0;
          }

          .MuiAccordion-root {
            width: 100% !important;
            box-shadow: none;

            .subtitle {
              display: flex;
              font-size: 1.0rem;

              .bold {
                font-weight: 900;
              }
            }

            .MuiAccordionSummary-root {
              min-height: 25px;
              height: 25px;
              padding: 0;

              .MuiTypography-root {
                width: 100%;
                justify-content: space-between;
                display: flex;
                align-items: center;

                .title {
                  color: black;
                  font-weight: 300;
                  font-size: 1.5rem;
                }
              }
            }

            .MuiAccordionDetails-root {
              padding: 20px 0 0 0;

              .MuiTypography-root {
                width: 100%;

                .MuiDivider-root {
                  display: none;
                }

                .MuiAccordionSummary-root {
                  min-height: auto;
                  height: auto;

                  .MuiAccordionSummary-content {
                    margin: 0;

                    .content {
                      padding: 0;
                    }
                  }
                }

                .date {
                  align-items: center;
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 20px;
                }
              }
            }
          }
        }
      }

      .vehicle-travel-details__item-grid--alerts {
        display: grid;
        grid-template-columns: 300px 300px;
      }
    }
  }

  .vehicle-travel-details__content--mobile {
    padding: 15px;
    overflow-x: hidden;

    .MuiPaper-root {
      max-width: 100%;
    }

    .MuiDialogContentText-root {
      width: 100%;
    }

    .vehicle-travel-details__work-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .content {
        padding-left: 15px;

        .title {
          font-weight: 500;
          color: black;
          text-transform: uppercase;
        }

        .subtitle {
          font-size: 1rem;
          color: #666666;
        }
      }
    }

    .events {
      margin-top: 15px;

      .MuiAccordion-root {
        margin: 0;
        box-shadow: none;

        .water-addition {
          min-height: unset;

          .MuiAccordionSummary-content.Mui-expanded {
            margin: 0;
          }
          .MuiIconButton-root {
            padding: 0 12px;
          }
        }

        .subtitle {
          padding-left: 8px;
          display: flex;
          font-size: 1.0rem;

          .bold {
            font-weight: 900;
          }
        }

        .MuiAccordionSummary-root {
          padding: 0 8px;

          .MuiAccordionSummary-content {

            .content {
              padding-bottom: 0;
            }

            .MuiTypography-root {
              font-weight: 500;
              font-size: 1.4rem;
              display: flex;
              width: 100%;
              justify-content: space-between;
            }
          }
        }

        .MuiCollapse-container {

          .MuiAccordionDetails-root {
            padding: 15px 10px 0 10px;

            .MuiTypography-root {
              width: 100%;

              .date {
                display: flex;
                justify-content: space-between;
                font-weight: 300;
                margin-bottom: 20px;
                font-size: 1.2rem;

                .title {
                  color: red;
                  padding-right: 10px;
                }
              }
            }

            .boxHeaderItems {
              padding: 0;

              .MuiAccordionSummary-content {

                .content {
                  padding: 0;
                }
              }
            }

            .hidden {
              display: none !important;
            }

            .staticMap {
              display: flex;
              justify-content: center;
              height: 250px;
              align-items: center;
              background-image: url(${BlurMap});
              background-repeat: no-repeat;
              background-size: cover;

              img {
                cursor: pointer;
                width: 40px;
                border-radius: 50%;
                font-weight: bold;
                background-color: white;
                /* box-shadow: 10px 10px 5px 0px rgb(0 0 0 / 75%); */
              }
            }

            .drawerMap {
              display: flex;
              justify-content: center;
              height: 250px;
              align-items: center;
              background-image: url(${BlurMap});
              background-repeat: no-repeat;
              background-size: cover;
            }
          }
        }
      }
    }

    .current-load {

      .current-load-information__icon {
        width: 30px;
        height: 30px;
      }

    }

    .water-additions {
      .MuiAccordion-root {
        margin: 0;
        box-shadow: none;

        .MuiAccordionSummary-root.Mui-expanded {
          min-height: unset;
        }

        .MuiAccordionSummary-content.Mui-expanded {
          margin-bottom: 0;
        }

        .MuiIconButton-root {
          padding: 0 12px;
        }

        .subtitle {
          padding-left: 8px;
          display: flex;
          font-size: 1.0rem;
          margin-bottom: 10px;
          line-height: 0.8rem;

          .bold {
            font-weight: 900;
          }
        }

        .MuiAccordionSummary-root {
          padding: 0 8px;

          .MuiAccordionSummary-content {

            .content {
              padding-bottom: 0;
            }

            .MuiTypography-root {
              font-weight: 500;
              font-size: 1.4rem;
              display: flex;
              width: 100%;
              justify-content: space-between;
            }
          }
        }

        .MuiCollapse-container {

          .MuiAccordionDetails-root {
            padding: 15px 10px 0 10px;

            .MuiTypography-root {
              width: 100%;

              .date {
                display: flex;
                justify-content: space-between;
                font-weight: 300;
                margin-bottom: 20px;
                font-size: 1.2rem;

                .title {
                  color: red;
                  padding-right: 10px;
                }
              }
            }

            .boxHeaderItems {
              padding: 0;

              .MuiAccordionSummary-content {

                .content {
                  padding: 0;
                }
              }
            }
          }
        }
      }
    }

    .states {

      .MuiAccordion-root {
        margin: 0;
        box-shadow: none;

        .MuiAccordionSummary-root {
          padding: 0 8px;

          .MuiAccordionSummary-content {

            .MuiTypography-root {
              font-weight: 500;
              font-size: 1.4rem;
            }
          }
        }

        .MuiCollapse-container {

          .MuiAccordionDetails-root {
            padding: 5px 10px;

            .MuiTypography-root {
              width: 100%;

              .date {
                display: flex;
                justify-content: space-between;
                font-weight: 300;
                margin-bottom: 20px;
                font-size: 1.2rem;

                .title {
                  color: red;
                  padding-right: 10px;
                }
              }
            }
          }
        }
      }
    }

    .vehicle-travel-details__map {
      margin-top: 0;

      .MuiAccordion-root {
        margin: 0;
        box-shadow: none;

        .MuiAccordionSummary-root {
          padding: 0 8px;

          .MuiAccordionSummary-content {

            .MuiTypography-root {
              font-weight: 500;
              font-size: 1.4rem;
            }
          }
        }

        .MuiAccordionDetails-root {

          .MuiTypography-root {
            width: 100%;
          }
        }
      }
    }
  }

  .current-load-information {
    display: flex;
    align-content: space-between;
    align-items: center;
    padding: 0 0 15px 0;

    &__icon {
      svg {
        width: 37px;
        height: 37px;
      }
    }

    &__details {
      width: 100%;
      padding-left: 15px;

      &--title {
        font-size: 0.9rem;
        font-weight: bold;
      }

      &--amount {
        display: flex;
        align-content: space-between;
        align-items: center;

        p {
          font-weight: bold;
        }
      }

      &--observation {
        font-size: 0.8rem
      }
    }
  }

  .vehicle-travel-details__footer {
    justify-content: flex-end;
  }


  .blue-background-badge {
    .MuiBadge-badge {
      background-color: #3D9AFF;
    }
  }
`;
